module.exports = {
  footerText: `Copyright Phillips Outsourcing © ${new Date().getFullYear()}`,
}
